import { useIntervalFn, useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { RATES_RELOAD_INTERVAL } from '~/config'
import { useApp } from '~/hooks/app'
import { getCoinStats } from '~/utils/api'

export type PriceData = {
  price: number
  vol24: number
  change24: number
  changePercent24: number
}

const defaultPriceData = {
  price: 0,
  vol24: 0,
  change24: 0,
  changePercent24: 0,
}
export const useCoinRateStore = defineStore('coin-rate', () => {
  const solana = useLocalStorage<PriceData>('solana-price', { ...defaultPriceData })
  const loading = ref(true)
  const { isClient } = useApp()

  async function load() {
    if (!isClient.value) {
      return
    }
    try {
      loading.value = true
      const resp = await getCoinStats()

      if (resp.solana) {
        solana.value.price = resp.solana.current_price
        solana.value.vol24 = resp.solana.total_volume
        solana.value.change24 = resp.solana.price_change_24h
        solana.value.changePercent24 = resp.solana.price_change_percentage_24h_in_currency
      }
    } catch (error) {
      console.error(error)
    } finally {
      loading.value = false
    }
  }

  onMounted(() => {
    useIntervalFn(load, RATES_RELOAD_INTERVAL, { immediateCallback: true })
  })

  return {
    solana,
    loading,
    load,
  }
})
